import { Badge } from 'uikit';

import type { IBimLevelBadgeProps } from './types';
import { getItemPriceLevelLabelFromId } from './types';

import Styles from './bimPriceLevel.module.css';

export const BimPriceLevelBadge = (props: IBimLevelBadgeProps) => {
    const { priceLevel, className, ...rest } = props;

    const name = getItemPriceLevelLabelFromId(priceLevel);

    return <Badge label={`Уровень цен: ${name}`} className={`${Styles.defaultStyle} ${className}`} {...rest} />;
};

BimPriceLevelBadge.displayName = 'BimPriceLevelBadge';
